import { Component, Input } from '@angular/core';

@Component({
  selector: 'confidence-icon',
  templateUrl: '../../assets/images/icon-confidence.svg'
})
export class ConfidenceIconComponent {
    @Input() mainColor = 'rgb(25, 255, 0)';

  changeColor() {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    this.mainColor = `rgb(${r}, ${g}, ${b})`;
  }
}